"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Table = _interopRequireDefault(require("../Table"));
var _excluded = ["schema", "excludeFields", "where", "onClickItem", "limit", "className", "findObject"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/OutputTable/index.js";
var defaultProps = {
  where: {},
  limit: 10
};
function OutputTable(_ref) {
  var schema = _ref.schema,
    excludeFields = _ref.excludeFields,
    where = _ref.where,
    onClickItem = _ref.onClickItem,
    limit = _ref.limit,
    className = _ref.className,
    findObject = _ref.findObject,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    objects = _React$useState2[0],
    setObjects = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(true),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    progress = _React$useState4[0],
    setProgress = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(1),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    current = _React$useState6[0],
    setCurrent = _React$useState6[1];
  var sort = {
    createdAt: -1
  };
  var getObjects = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var skip, query, _yield$findObject$exe, count, _objects;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            skip = (current - 1) * limit;
            query = {
              count: true,
              limit: limit,
              skip: skip,
              where: where,
              include: ["all"],
              sort: sort
            };
            setProgress(true);
            _context.prev = 3;
            _context.next = 6;
            return findObject.execute(schema.collection, query);
          case 6:
            _yield$findObject$exe = _context.sent;
            count = _yield$findObject$exe.count;
            _objects = _yield$findObject$exe.objects;
            setObjects(_objects);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
          case 15:
            setProgress(false);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 12]]);
    }));
    return function getObjects() {
      return _ref2.apply(this, arguments);
    };
  }();
  function onClick(i) {
    onClickItem(objects[i]);
  }
  _react["default"].useEffect(function () {
    getObjects();
  }, [where]);
  return /*#__PURE__*/_react["default"].createElement(_Table["default"], Object.assign({
    onClick: onClick,
    fields: schema.fields,
    objects: objects,
    progress: progress,
    excludeFields: excludeFields,
    className: className
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }));
}
OutputTable.defaultProps = defaultProps;
var _default = exports["default"] = OutputTable;